import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TRANSLATE} from '../../classes/translatable';
import {SelectionModel} from '@angular/cdk/collections';

export class DeleteValidationDialogData <T>{
  deleteMessage                   = TRANSLATE("Voulez-vous vraiment supprimer cet élément");
  selection: SelectionModel<any>  = null;
  getRefToDisplay: any            = null;
  isArchive                       = false;
  isPrimary                       = false;
  buttonWording: string           = TRANSLATE('Supprimer');
  title: string                   = "Suppression";
}

@Component({
  selector: 'app-delete-validation-dialog',
  templateUrl: './delete-validation-dialog.component.html',
  styleUrls: ['./delete-validation-dialog.component.css']
})
export class DeleteValidationDialogComponent <T>implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<DeleteValidationDialogComponent<T>>,
      @Inject(MAT_DIALOG_DATA) public data: DeleteValidationDialogData<T> = new DeleteValidationDialogData()
  ) { }

  ngOnInit() {
    if (!this.data)
      this.data = new DeleteValidationDialogData();
    this.dialogRef.disableClose = true;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  fallbackButtonWording() {
    if (this.data.buttonWording !== null)
      return this.data.buttonWording;
    else if (this.data.isArchive)
      return "Archiver";
    else
      return "Supprimer";
  }
}
